import { render, staticRenderFns } from "./step-item-details.vue?vue&type=template&id=f5a810c8&"
import script from "./step-item-details.vue?vue&type=script&lang=js&"
export * from "./step-item-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports